<template>
  <div id="contenedor-tablero-proyecto" class="main-contenedor-tablero">
    <v-row class="fill-height">
      <v-col
        cols="12"
        md="6"
        order="2"
        class="fill-height">
        <Chat :id-proyecto="idProyecto"></Chat>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        md="6"
        order="1">
        <div class="rounded-lg px-2" style="border: 1px solid #eee;">
          <v-toolbar
            dense
            flat
            class="mt-2">
            <v-toolbar-title>
              Documentos
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              class="custom-transform-class text-none caption"
              :to="{ name: 'obraProyectoDocumentos' }">
              Ver todos
            </v-btn>
          </v-toolbar>
          <v-divider class="mx-2"></v-divider>
          <ListadoDocumentos :id-proyecto="idProyecto"></ListadoDocumentos>
        </div>
        <div class="mt-4">
          <Validaciones :id-proyecto="idProyecto"></Validaciones>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Chat from '@/components/administracion/control-proyectos/comentarios/Chat.vue';
import ListadoDocumentos from '@/components/administracion/control-proyectos/documentos/listado/Listado.vue';
import Validaciones from '@/components/administracion/control-proyectos/responsables/Validador.vue';

export default {
  name: 'TableroProyecto',
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  components: {
    Chat,
    ListadoDocumentos,
    Validaciones,
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss">
.main-contenedor-tablero {
  min-height: calc(100vh - 300px);
  min-height: calc(100svh - 300px);
  height: calc(100svh - 300px);
  overflow: hidden;
}
</style>
